app.service('productsInComparison', function(localStorage, modal) {
	let productsInComparison = [];

	function add(product) {
		if (getByGroupId(product.groupId).length === 3) {
			modal.alert('Możesz porównać maksymalnie 3 Towary');
			return false;
		}

		productsInComparison.push(product);
		save();

		return true;
	}

	function remove({ productId }) {
		productsInComparison = productsInComparison.filter(
			p => p.productId !== productId
		);
		save();
	}

	function save() {
		localStorage.setItem(
			'products_in_comparison',
			JSON.stringify(productsInComparison)
		);
	}

	function getByGroupId(groupId) {
		return productsInComparison.filter(p => p.groupId === groupId);
	}
	function getLastSelectedGroupId() {
		return productsInComparison.length ? productsInComparison.slice(-1)[0].groupId : '';
	}

	function has(productId) {
		return productsInComparison.filter(p => p.productId === productId).length;
	}

	function getProductsInComparison() {
		return JSON.parse(localStorage.getItem('products_in_comparison')) || [];
	}

	function init() {
		update();
	}

	function update() {
		productsInComparison = getProductsInComparison();
	}

	return {
		init,
		add,
		has,
		remove,
		getByGroupId,
		getLastSelectedGroupId,
		update
	};
});
